export enum GlobalActionTypes {
    SET_LOADING = 'SET_LOADING',
    SET_COMPONENT_LOADING = 'SET_COMPONENT_LOADING',
    SET_PLATFORM = 'SET_PLATFORM',
    GET_APP_DATA = 'GET_APP_DATA',
    SET_TRANSACTION_PLATFORM = 'SET_TRANSACTION_PLATFORM',
    SET_IS_IN_PRODUCT_DETAIL = 'SET_IS_IN_PRODUCT_DETAIL'
}
